import { Component, Inject, ViewContainerRef, TemplateRef } from '@angular/core';
import { PagerService } from '../../services/shared/pager.service';
import { BlogCategoryService } from '../../services/blog/blog-category.service';
import { BlogCategory } from '../../models/blog/blog-category-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-blogcategory-list',
    templateUrl: './blogcategory-list.component.html',
    styleUrls: ['./blogcategory-list.component.css']
})
/** blogcategory-list component*/
export class BlogcategoryListComponent {
    /** blogcategory-list ctor */
  public blogCategoryList: BlogCategory[];
  // pager object
  searchKeyword: string; 
  // paged items
  filteredItems: any[];
  isActive: string;
  pager: any = {};
  pageSize: number;
  pagedItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  constructor(private readonly blogCategoryService: BlogCategoryService,
    private readonly utilitiesService: UtilitiesService,
    private readonly pagerService: PagerService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("blogcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.getBlogCategory();
          this.pageSize = 10;
          this.GetRowsPerPageList();
          this.toastr.setRootViewContainerRef(vcr);
            this.isActive = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )

  }
    deleteBlogCategory(id) {
    if (confirm("Are you sure to delete this blog category ?")) {
      this.blogCategoryService.deleteBlogCategory(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Blog Category has been Deleted', 'Success');
            setTimeout(() => {
              this.getBlogCategory();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Oop!', 'Success');
          }
        }
      )
    }
  }
  getBlogCategory() {
    this.blogCategoryService.getBlogCategory().subscribe(
      data => {
        this.blogCategoryList = data
        this.filteredItems = data;
      }

    )
  }
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  OnFilterChange() {
    this.filteredItems = this.blogCategoryList;

    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    } else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }



  }
}



// WEBPACK FOOTER //
// ./src/app/blog-components/blogcategory-list/blogcategory-list.component.ts